module.exports = __webpack_public_path__ + "img/uob.67e92f2e.svg";